<template>
  <div v-if="instructions">
    <div v-for="(block, index) in instructions.blocks" :key="index">
      <h1 v-if="block.type === 'header' && block.data.level === 1" class="my-1">
        {{ block.data.text }}
      </h1>
      <h2 v-if="block.type === 'header' && block.data.level === 2" class="my-1">
        {{ block.data.text }}
      </h2>
      <h3 v-if="block.type === 'header' && block.data.level === 3" class="my-1">
        {{ block.data.text }}
      </h3>
      <h4 v-if="block.type === 'header' && block.data.level === 4" class="my-1">
        {{ block.data.text }}
      </h4>
      <h5 v-if="block.type === 'header' && block.data.level === 5" class="my-1">
        {{ block.data.text }}
      </h5>
      <h6 v-if="block.type === 'header' && block.data.level === 6" class="my-1">
        {{ block.data.text }}
      </h6>
      <p v-if="block.type === 'paragraph'" v-html="block.data.text"></p>
      <ol v-if="block.type === 'list' && block.data.style === 'ordered'">
        <li
          v-for="(text, index) in block.data.items"
          :key="index"
          v-html="text"
        ></li>
      </ol>
      <ul v-if="block.type === 'list' && block.data.style === 'unordered'">
        <li
          v-for="(text, index) in block.data.items"
          :key="index"
          v-html="text"
        ></li>
      </ul>
      <div
        v-if="block.type === 'image'"
        :class="{
          withBorder: block.data.withBorder,
          withBackground: block.data.withBackground
        }"
      >
        <img v-if="block.data.stretched === false" :src="block.data.file.url" />
        <v-img v-else :src="block.data.file.url"></v-img>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RecipeInstructionsRenderer",
  props: {
    instructions: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.withBorder {
  border-radius: 4px;
  border: 1px solid #e8e8eb;
}
.withBackground {
  border-radius: 4px;
  padding: 15px;
  background: #f5f5f5;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
